import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "What is PLST?", a: "PLST stands for Physio-Led Strength Training. It combines physiotherapy expertise with structured strength training to create an exercise program built around your body, your goals and where you are today." },
  { q: "Do I need to be fit or have experience with strength training?", a: "Not at all. You can start exactly where you are. Whether you've never lifted a weight before or already train regularly, your program and level of guidance are adapted to you." },
  { q: "How is PLST different from a regular gym?", a: "At PLST, you don't just walk in and figure out what to do. Your training has a plan and a purpose. A physiotherapist understands your goals and guides your exercises, loads and progressions. No random workouts — just training with intent." },
  { q: "Do I need an assessment before I start?", a: "We start with a conversation and an assessment to understand your health, exercise history, injuries, movement and goals. This helps us decide where you should start and what your program should look like." },
  { q: "Do I need a doctor's referral?", a: "No. You can contact us directly to start PLST or physiotherapy. If we feel you need further medical evaluation before or during your journey, we'll guide you accordingly." },
  { q: "Where are you located?", a: "PLST is currently available at our centres in Vile Parle and Andheri West (Lokhandwala), Mumbai, and Thane." },
  { q: "What is the difference between 1-to-1 and semi-supervised PLST?", a: "In 1-to-1 PLST, you train with dedicated guidance from your physiotherapist throughout the session. In semi-supervised PLST, you follow your individual program more independently, with a physiotherapist available to guide your technique, loads and progressions." },
  { q: "Can I do PLST if I have pain or an injury?", a: "Yes, in many cases. That's one of the advantages of being in a physiotherapist-led environment. We'll understand your condition and decide whether you can begin PLST directly or whether physiotherapy and rehabilitation should come first." },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 lg:py-40 bg-white border-t border-[#1E1E1E]/10" data-testid="faq-section">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
          className="lg:col-span-4"
        >
          <div className="text-xs uppercase tracking-[0.28em] text-[#8A8A8A]">
            <span className="w-8 h-px bg-[#A67C00] inline-block align-middle mr-3" />
            FAQs
          </div>
          <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
            Everything <br />
            <span className="italic font-medium text-[#A67C00]">you might ask</span> <br />
            on the phone.
          </h2>
          <p className="mt-6 text-[#1E1E1E]/70">
            Still unsure? Talk to us. It's the fastest way to get the honest answer for your body.
          </p>
        </motion.div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#1E1E1E]/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display font-semibold text-xl md:text-2xl tracking-tight py-6 hover:no-underline hover:text-[#A67C00] text-[#1E1E1E]"
                >
                  <span className="flex items-baseline gap-4">
                    <span className="italic font-medium text-lg text-[#A67C00]">{String(i + 1).padStart(2, "0")}</span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-[#1E1E1E]/75 text-base md:text-lg leading-relaxed pb-6 pl-9 whitespace-pre-line">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
